import styled from "styled-components";

export const Editar = styled.div`
    background-color: #fff;
    border-radius: 8px;
    box-shadow: rgba(33, 35, 38, 0.1) 2px 10px 10px -10px;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transition: opacity 0.5s ease, visibility 0.5s ease;
    width: 90%;
    transform: translate(5%, 5%);
    max-height: auto;
  

    .center-circular-progress{
    text-align:center;
        position: relative;
    top: -20px;
    }

    .format-file{
        border: 1px solid #e9e9e9;
    padding: 0 10px;
    border-radius: 4px;
    margin-bottom: 10px;
    
    }
    .format-btn{
    margin: 10px 5px 0 5px;
    }
 

  .displayFlex {
    display: flex;
    background: #005a9e;
    border-radius: 8px 8px 0px 0px;
    color: #fff;
  }

  .msgFilter{
  text-align:center;
  }

  .center{
  margin: 0 auto;
  }

  .inputSerach {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .btn-close,
  .title {
    padding: 10px;
  }

  .title {
    width: 100%;
  }

  .close {
    font-size: 30px;
    color: #fff;
    cursor: pointer;
  }

  .modal-title {
    font-size: 20px;
    padding: 10px;
  }

  .title {
    span {
      position: relative;
      top: 7px;
    }
  }

  .btn-site-div {
    display: flex;
    justify-content: flex-end;
    margin: 10px 14px;

    .btn-site {
          background: #005a9e;
    color: #fff;
    }
  }

  .loading {
      position: absolute;
      right: 50%;
      top: 50%;
    }
`;

export const ModalOverlayHeader = styled.div`
  position: fixed;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  transition: opacity 0.5s ease, visibility 0.5s ease;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`;

export const FormContent = styled.div`
    margin: 30px 100px;


    width{
    width: 10px;
    height: 10px;
    }


    .btn-model{
        padding: 10px;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    margin: 5px;
    }

    .bg-padrao{
    background: #005A9E;
    color: #fff;    
    }

    .form-content {
      display: flex;
      justify-content: space-between;

      label {
      color: #6f6e6e;
       font-weight: 700;
        font-size: 12px;
      }

      
        .float-button-2 {
         position: absolute;
        top: 54px;
        right: -50px;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 1px 4px;
      }
    }

    .form-item {
      
    margin: 10px;
    }

    .btn-save {
      background: #005a9e;
      height: 40px;
      width: 200px;
      border-radius: 8px;
      color: #fff;
    }
  }

.tooltip {
    position: absolute;
    right: 10%;
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.tooltip-download {
    position: absolute;
    right: 30%;
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.float-buttons {
    display: flex;
}

.float-button:hover .tooltip {
    opacity: 1;
}

.button {
    background-color: #fff;
    color: #6f6e6e;
    padding: 10px 15px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    transition: background-color 0.3s ease;
    margin-bottom: 10px;
    margin-right: 6px
}

.button:hover {
    background-color: #22385121;
}

.files {
      display: flex;
    justify-content: space-between;
}

.files:hover {
  background-color: #2238510f;
}

.exclamation-icon {
  color: crimson;
  font-size: 20px;
  margin-right: 10px;
}
`;

export const Select = styled.div`
  display: flex;
  margin: 22px 6px;

  select {
        border: none;
    height: 40px;
    border-radius: 8px;
    padding: 10px;
    width: 112px;
    color: #737373;
  }

  select:hover {
    border: none;
  }
`;

export const LoadingOverlay = styled.div`
opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;